import React from 'react';
import { useInView, motion } from 'framer-motion';
import * as S from './styles';

export const CTAFinal: React.FC = () => {
  const ref = React.useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.12 });

  return (
    <S.Section id="download" ref={ref}>
      <motion.span
        initial={{ opacity: 0, y: 26 }}
        animate={isInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.6 }}
      >
        <S.SectionTag>Comece agora</S.SectionTag>
      </motion.span>
      <S.SectionTitle
        as={motion.h2}
        initial={{ opacity: 0, y: 26 }}
        animate={isInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.6, delay: 0.1 }}
      >
        Sua próxima excursão
        <br />
        merece ser perfeita.
      </S.SectionTitle>
      <motion.p
        initial={{ opacity: 0, y: 26 }}
        animate={isInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.6, delay: 0.2 }}
      >
        <S.SectionSub>
          Junte-se a centenas de organizadores que já simplificaram sua vida.
          Grátis para baixar, sem cartão de crédito.
        </S.SectionSub>
      </motion.p>
      <motion.div
        initial={{ opacity: 0, y: 26 }}
        animate={isInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.6, delay: 0.3 }}
      >
        <S.StoreBtns>
          <S.StoreBtn href="#">
            <S.StoreBtnIcon>▶</S.StoreBtnIcon>
            <S.StoreBtnText>
              <small>Disponível no</small>
              <strong>Google Play</strong>
            </S.StoreBtnText>
          </S.StoreBtn>
        </S.StoreBtns>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 26 }}
        animate={isInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.6, delay: 0.4 }}
      >
        <S.Reassurance>
          <span>100% Gratuito</span>
          <span>Sem cadastro complexo</span>
          <span>Suporte em português</span>
        </S.Reassurance>
      </motion.div>
    </S.Section>
  );
};
